<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <v-layout row>
          <v-flex xs12>
            <v-card>
              <card-toolbar title="Raporlar">
              </card-toolbar>

              <v-card-text>
                <v-flex xs12>
                  <!-- RAPORLAR -->
                  <v-layout :row="$vuetify.breakpoint.smAndDown" :wrap="!$vuetify.breakpoint.xl">
                    <!-- FİLTRE -->
                    <v-flex xs12 md12 xl3>
                      <v-form ref="form" v-model="isFormValid" class="w-100" lazy-validation
                        @submit.prevent="loadReportsBetweenDates()">
                        <v-flex xs12>
                          <!-- START DATE -->
                          <date-month-picker label="Başlangıç Tarihi" :rules="[$rules.required({
                            falseValues: ['', undefined],
                            message: 'Bir başlangıç tarihi seçmelisiniz'
                          })]" @on:date-selected="(val) => { form.start_date = val; }">
                          </date-month-picker>
                          <!-- START DATE -->
                          <date-month-picker label="Bitiş Tarihi" :rules="[$rules.required({
                            falseValues: ['', undefined],
                            message: 'Bir bitiş tarihi seçmelisiniz'
                          })]" @on:date-selected="(val) => { form.end_date = val; }">
                          </date-month-picker>
                        </v-flex>
                        <v-flex xs12 class="d-flex justify-end justify-xl-space-between">
                          <v-btn class="mr-2" color="primary" :disabled="form.end_date === '' || form.start_date === ''"
                            @click="resetForm()">
                            Seçimi Temizle
                          </v-btn>

                          <v-btn type="submit" color="primary">
                            Raporları Yükle
                          </v-btn>
                          <!-- <v-btn
                            color="primary"
                            @click.stop="loadReportsBetweenDates"
                            :disabled="form.end_date === '' || form.between_date === ''"
                          >
                            Raporları Yükle
                          </v-btn> -->
                        </v-flex>
                      </v-form>
                    </v-flex>
                    <v-divider v-if="$vuetify.breakpoint.lgAndUp" vertical>
                    </v-divider>
                    <v-flex md12 xs12 xl9 class="overflow-auto">
                      <!-- TABLE -->
                      <v-data-table hide-default-footer :headers="headers" :items="data">
                        <template v-slot:item.status="{ item }">
                          <v-chip color="warning" class="mb-3 mt-3" style="background: rgba(0,0,0,.12)!important;"
                            v-if="item.status == 0">
                            Gönderiliyor
                          </v-chip>
                          <br />
                          <v-btn v-if="item.status == 0" style="margin-bottom: 12px;" class="warning" small
                            @click="stopWhatsapp(item.id)">
                            Durdur
                          </v-btn>
                          <v-chip color="success" class="mb-3 mt-3" text-color="white" v-else-if="item.status == 1">
                            Başarılı
                          </v-chip>
                          <v-chip color="primary" class="mb-3 mt-3" text-color="white" v-else-if="item.status == 2">
                            İade Edildi
                          </v-chip>

                          <v-chip color="primary" class="mb-3 mt-3" text-color="white" v-else-if="item.status == 3">
                            Durduruldu
                          </v-chip>

                          <v-chip color="red" class="mb-3 mt-3" text-color="white" v-else-if="item.status == 4">
                            İptal Edildi
                          </v-chip>
                        
                          <v-chip color="red" class="mb-3 mt-3" text-color="white" v-else-if="item.status == 5">
                            Whatsapp Kullanmıyor
                          </v-chip>
                        
                          <div style="display: flex; gap: 12px; margin-bottom: 12px;">
                            <v-btn v-if="item.status == 3" class="warning" small @click="cancelWhatsapp(item.id)">
                              İptal Et
                            </v-btn>

                            <v-btn v-if="item.status == 3" class="warning" small @click="continueWhatsapp(item.id)">
                              Devam Ettir
                            </v-btn>
                          </div>

                        </template>
                        <template v-slot:item.detail="{ item }">
                          <v-row justify="end" dense>
                            <v-col cols="auto">
                              <v-btn @click="detail(item)" small
                                v-if="item.whatsapp_send_count != 0 && item.on_queue && item.count <= 0 && item.status != 2"
                                disabled="disabled">
                                Detay
                              </v-btn>
                              <v-btn v-else dark @click="detail(item)" small
                                :disabled="item.whatsapp_send_count != 0 && item.on_queue && item.count <= 0 && item.status != 2">Detay
                              </v-btn>
                            </v-col>
                            <v-col cols="auto">
                              <v-btn color="primary" @click="exportExcel(item)" small
                                :disabled="item.whatsapp_send_count != 0 && item.on_queue && item.count <= 0 && item.status != 2">
                                Excel
                              </v-btn>
                            </v-col>
                          </v-row>
                        </template>
                        <template v-slot:item.is_sub_user="{ item }">
                          <!-- Sender her zaman gösterilecek -->
                          <v-chip v-text="item.sender.sender" style="margin-bottom: 10px;"></v-chip>

                          <!-- Altındaki diğer içerik -->
                          <div>
                            <v-chip v-if="item.is_sub_user === false" v-text="'Ana Kullanıcı'"></v-chip>
                            <v-chip v-else v-text="`Alt Kullanıcı: ${item.user.name} ${item.user.surname}`"></v-chip>
                          </div>
                        </template>
                      </v-data-table>
                      <pagination :pagination="pagination" :action="onPagination">
                      </pagination>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Pagination from '../../Components/Datatables/Pagination.vue';
import DateMonthPicker from '../../Components/WhatsappConstants/DateMonthPicker.vue';
import { downloadFile } from '../../../misc';
import CardToolbar from '../../Components/CardToolbar.vue';
// import DynamicAlert from '../../Components/DynamicAlert.vue';

export default {
  name: 'Report',
  components: {
    // DynamicAlert,
    CardToolbar,
    DateMonthPicker,
    Pagination,
  },
  data: () => ({
    menu: false,
    isFormValid: true,
    isFiltered: false,
    form: {
      start_date: '',
      end_date: '',
    },
    headers: [
      {
        text: 'Tarih',
        value: 'created_at',
      },
      {
        text: 'Mesaj',
        value: 'message',
      },
      {
        text: 'Durumu',
        value: 'status',
        align: 'center',
      },
      {
        text: 'Toplam Gönderilen',
        value: 'count',
        align: 'center',
      },
      {
        text: 'Işlem',
        value: 'detail',
        align: 'right',
      },
      {
        text: 'Gönderen',
        value: 'is_sub_user',
      },
    ],
    data: [],
    oztek: {
      account: null,
      loggedIn: false,
      info: '01 Ocak 2020 öncesi raporlarınızı buraya tıklayarak görüntüleyebilirsiniz.',
    },
    pagination: {
      current: 1,
      total: 0,
    },
  }),
  computed: {
    ...mapState(['user']),
    stationary() {
      return [
        {
          type: 'warning',
          state: this.oztek.loggedIn,
          id: 'warning',
        },
      ];
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'pagination.current': function () {
      // eslint-disable-next-line no-unused-expressions
      this.isFiltered ? this.loadReportsBetweenDates() : this.loadReports();
    },
  },
  created() {
    this.writepage();
    this.loadReports();
  },
  methods: {
    redirectToReportSearch() {
      this.$router.push({ name: 'whatsapp.report.search' });
    },
    ...mapActions({ send: 'sendBackend' }),
    ...mapActions({ sendAsync: 'asyncSender' }),
    downloadFile,
    writepage() {
      if (this.$route.params.page) {
        this.pagination.current = this.$route.params.page;
      }
    },

    cancelWhatsapp(id) {
      const route = 'whatsapp/cancel';
      this.send({
        route,
        data: { id },
      }).then(() => {
        if (this.isFiltered) {
          this.loadReportsBetweenDates();
        } else {
          this.loadReports();
        }
      });
    },
    continueWhatsapp(id) {
      const route = 'whatsapp/continue';
      this.send({
        route,
        data: { id },
      }).then(() => {
        if (this.isFiltered) {
          this.loadReportsBetweenDates();
        } else {
          this.loadReports();
        }
      });
    },
    stopWhatsapp(id) {
      const route = 'whatsapp/stop';
      this.send({
        route,
        data: { id },
      }).then(() => {
        if (this.isFiltered) {
          this.loadReportsBetweenDates();
        } else {
          this.loadReports();
        }
      });
    },

    loadReports() {
      const url = `whatsapp/reports?page=${this.pagination.current}`;
      this.send({
        route: url,
      }).then((res) => {
        this.data = res.data.data.reports.data.filter(report => report.sender !== null);
        this.pagination.current = res.data.data.reports.current_page;
        this.pagination.total = res.data.data.reports.last_page;
      });
    },

    loadReportsBetweenDates() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.isFiltered = true;
      const url = `whatsapp/reports/between?page=${this.pagination.current}`;
      this.send({
        route: url,
        data: {
          start_date: this.form.start_date,
          end_date: this.form.end_date,
        },
      }).then((res) => {
        this.data = res.data.data.data.filter(report => report.sender !== null);
        this.pagination.current = res.data.data.current_page;
        this.pagination.total = res.data.data.last_page;
      });
    },
    onPagination($page = 1) {
      this.pagination.current = $page;
    },
    exportExcel(report) {
      const route = 'whatsapp/export/report/details/';
      const fileName = `${this.user.id}-${report.created_at}`;
      this.$http
        .get(route + report.id, {
          responseType: 'arraybuffer',
        })
        .then((res) => {
          this.downloadFile(res, fileName);
        });
    },
    detail(report) {
      this.$router
        .push({
          name: 'whatsapp.report.detail',
          params: {
            id: report.id,
            export: this.exportExcel,
            page: this.pagination.current,
            report,
            page: this.pagination.current,
          },
        })
        .catch(() => {
        });
    },
    resetForm() {
      this.form.start_date = '';
      this.form.end_date = '';
      this.$refs.form.reset();

      if (this.isFiltered) {
        this.loadReports();
        this.isFiltered = false;
      }
    },
    shortenDate(param) {
      const months = {
        Ocak: '01',
        Şubat: '02',
        Mart: '03',
        Nisan: '04',
        Mayıs: '05',
        Haziran: '06',
        Temmuz: '07',
        Ağustos: '08',
        Eylül: '09',
        Ekim: '10',
        Kasım: '11',
        Aralık: '12',
      };
      const [date, time] = param.split(',');
      const dateArr = date.split(' ');
      return `${dateArr[0]}/${months[dateArr[1]]}/${dateArr[2]}, ${time.split(' ')[2]}`;
    },
  },
};
</script>

<style scoped>
.text-decorative {
  text-decoration: underline;
}
</style>